import type { BrowseTrack } from "@touchscreen/api-client";
import "./RequestConfirmedOverlay.css";

export interface RequestConfirmedOverlayProps {
  track: BrowseTrack;
}

/** Temporary centered confirmation, shown over the same dark overlay as the request modal it replaces. */
export function RequestConfirmedOverlay(props: RequestConfirmedOverlayProps): React.JSX.Element {
  const { track } = props;
  return (
    <div className="request-confirmed" role="status" aria-live="polite">
      <div className="request-confirmed__card">
        <svg className="request-confirmed__check" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <circle cx="26" cy="26" r="26" fill="var(--brand-accent, #e94b8a)" />
          <path d="M15 27l7 7 15-15" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <p className="request-confirmed__eyebrow">Added to the queue</p>
        <h2 className="request-confirmed__title">{track.title}</h2>
        <h3 className="request-confirmed__artist">{track.artist}</h3>
      </div>
    </div>
  );
}
